import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "g-row g-row--appearance_spaced g-row--justify_between g-row--space_sm" }
const _hoisted_2 = { class: "g-cell g-cols g-cols--auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, { loading: $props.loading }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.filters.length)
            ? (_openBlock(), _createBlock($setup["FilterUi"], {
                key: 0,
                disabled: $props.loading,
                value: $setup.prepared,
                filters: $setup.filters,
                onInput: $setup.handleInput,
                onFiltrate: $setup.filtrate
              }, {
                append: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, "append", _normalizeProps(_guardReactiveProps({ ...scope, all: $props.all })))
                ]),
                _: 3
              }, 8, ["disabled", "value", "filters"]))
            : _createCommentVNode("", true)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "g-cell g-cols g-cols--12 g-cols--1-xl u-display u-display--block-xl" }, null, -1))
      ])
    ]),
    _: 3
  }, 8, ["loading"]))
}